
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[user]/group-otp-request",
      function () {
        return require("private-next-pages/[user]/group-otp-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[user]/group-otp-request"])
      });
    }
  